export default __webpack_public_path__ + "static/media/36k.0f546241.md";